exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-settings-plan-review .fts-settings-estimate-total{width:100%;max-width:560px}.fts-settings-plan-review .fts-settings-plan-review-amount{white-space:nowrap}", ""]);

// exports
